import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C5PdfPageSelectionEdit } from "./edit";
import { C5PdfPageSelectionNew } from "./new";
import { C5PdfPageSelectionTable } from "./table";

export default function C5PdfPageSelection() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_s_lection_de_pages_pdf", {
        ns: "titles",
        defaultValue: "Quantilia | PDF Page Selection",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route path=":id" element={<C5PdfPageSelectionEdit />} />
      <Route index element={<C5PdfPageSelectionTable />} />
      <Route path="/new" element={<C5PdfPageSelectionNew />} />
    </Routes>
  );
}
